import { Currency, Token } from '@pancakeswap-libs/sdk-v2' // todo
import React, { KeyboardEvent, RefObject, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { useAllTokens } from 'hooks/useAllTokens'
import { Text, CloseIcon } from '@pancakeswap-libs/uikit'
import { useErc721Token, useTokenBalances } from 'hooks/useToken'
import AutoSizer from 'react-virtualized-auto-sizer'
import QuestionHelper from 'components/QuestionHelper'
import useI18n from 'hooks/useI18n'
import { isAddress } from '../../utils'
import Column from './Column'
import { filterOptions } from './filtering'
import { useTokenComparator } from './sorting'
import { PaddedColumn, SearchInput, Separator } from './styleds'
import { RowBetween } from './Row'
import { SelectItem } from './ItemInter'
import List from './List'


interface CurrencySearchProps {
  // selectedCurrency?: Currency | null
  onSelect: (currency: SelectItem) => void
  onDismiss: () => void
  options: any
}

function CurrencySearch({
  onDismiss,
  onSelect,
  options
}: CurrencySearchProps) {
  const [searchQuery, setSearchQuery] = useState<string>('')
  const nftTokensAsset = options;

  const filteredTokens: any = useMemo(() => {
      const allTokens = nftTokensAsset;
      return filterOptions(options, searchQuery)
    }, 
    // eslint-disable-next-line
    [options, searchQuery]
  )

  const filteredSortedTokens: any = useMemo(() => {
    const symbolMatch = searchQuery
      .toLowerCase()
      .split(/\s+/)
      .filter((s) => s.length > 0)
    if (symbolMatch.length > 1) return filteredTokens

    return [
      // sort any exact name matches first
      ...filteredTokens.filter((token) => token.name?.toLowerCase() === symbolMatch[0]),
      ...filteredTokens.filter((token) => token.name?.toLowerCase() !== symbolMatch[0]),
    ]
  }, [filteredTokens, searchQuery])

  const handleCurrencySelect = useCallback(
    (currency: SelectItem) => {
      onDismiss()
      if(currency?.textId){
        setSearchQuery(TranslateString(currency?.textId,currency.name))
      }else{
        setSearchQuery(currency.name)
      }
      onSelect({...currency});
    },
    // eslint-disable-next-line
    []
  )

  // manage focus on modal show
  const inputRef = useRef<HTMLInputElement>()
  const handleInput = useCallback((event) => {
    const input = event.target.value
    setSearchQuery(input)
  }, [])

  const handleEnter = useCallback(
    (e: KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter') {
        const s = searchQuery.toLowerCase().trim()
        if (filteredSortedTokens.length > 0) {
          if (
            filteredSortedTokens[0].symbol?.toLowerCase() === searchQuery.trim().toLowerCase() ||
            filteredSortedTokens.length === 1
          ) {
            handleCurrencySelect(filteredSortedTokens[0])
          }
        }
      }
    },
    [filteredSortedTokens, handleCurrencySelect, searchQuery]
  )
  const TranslateString = useI18n()

  return (
    <Column style={{ width: '100%', flex: '1 1' }}>
      <PaddedColumn gap="14px">
        <RowBetween>
          <Text>
            {TranslateString(1388, "Select an Option")}
            <QuestionHelper
              text={TranslateString(1389, "Find an option by searching for its name.")}
            />
          </Text>
          <CloseIcon onClick={() => onDismiss()} />
        </RowBetween>
        <SearchInput
          type="text"
          autoComplete="new-password"
          placeholder={TranslateString(1390, "Search name")}
          value={searchQuery}
          ref={inputRef as RefObject<HTMLInputElement>}
          onChange={handleInput}
          onKeyDown={handleEnter}
        />
      </PaddedColumn>
      <div style={{ flex: '1' }}>
        <AutoSizer disableWidth>
          {({ height }) => (
            <List
              height={height}
              options={filteredSortedTokens}
              onSelect={handleCurrencySelect}
            />
          )}
        </AutoSizer>
      </div>
    </Column >
  )
}

export default CurrencySearch
